import { defineStore } from 'pinia'
import moment from 'moment'
import numeral from 'numeral'
import { DASHBOARD_PARTS_HISTORY } from '@/data/url'
import apiClient from '@/services/apiClient'

const defaultState = () => ({
    numeral,
    moment,
    table_key: 0,
    figureKey: 0,
    part_number: '',
    date_range: 'all',
    range: [moment('1999-01-01'), moment().endOf('quarter').toDate()],
    queryDataRaw: [],
    loading: false,
    error: null,
})

export const usePartHistoryStore = defineStore('partHistory', {
    state: () => ({
        ...defaultState(),
    }),
    actions: {
        addToFigureKeyPartHistory(addValue) {
            this.figureKey += addValue
        },
        addToTableKeyPartHistory(addValue) {
            this.table_key += addValue
        },
        setQueryDataRawPartHistory(data) {
            this.queryDataRaw = data
        },
        setResetPartHistory() {
            this.queryDataRaw = []
            this.part_number = ''
            this.date_range = ''
            this.range = [moment().startOf('quarter').toDate(), moment().endOf('quarter').toDate()]
            this.loading = false
            this.error = null
        },
        setRangePartHistory(range) {
            this.range = range
        },
        async fetchPartHistory({ part_number, begin_date, end_date } = {}) {
            this.loading = true
            this.error = null

            try {
                const response = await apiClient.post(DASHBOARD_PARTS_HISTORY, {
                    part_number: (part_number || '').trim(),
                    begin_date,
                    end_date,
                })

                const data = response.data
                if (data?.success) {
                    this.setQueryDataRawPartHistory(data.data || [])
                } else {
                    this.setQueryDataRawPartHistory([])
                }

                return data
            } catch (error) {
                this.error = error instanceof Error ? error.message : 'Unknown error'
                console.error('Failed to fetch part history', error)
                throw error
            } finally {
                this.loading = false
            }
        },
    },
})
